<template>
  <a-card class="card-table" :class="[{ 'table-custom-header': !title }, wrapperClass]">
    <template #title>
      <div v-if="title" class="cursor-pointer outline-none">
        <caret-right-outlined v-if="isShowIconColapse" :rotate="90" />
        <span class="font-semibold ml-[7px]">
          {{ device !== DEVICE_TYPE.MOBILE ? title : 'Kết quả' }}
        </span>
      </div>
      <slot v-else name="customerTitle" />
    </template>
    <template #extra>
      <div class="flex items-center gap-4 w-full">
        <slot name="preAction" />

        <c-input
          v-if="showQuickSearch"
          v-model:value="quickSearch"
          :class="device !== DEVICE_TYPE.MOBILE ? '!w-[300px]' : '!w-[250px]'"
          placeholder="Tìm kiếm nhanh..."
          @change="handleChangeValueSearch"
        >
          <template #prefix>
            <search-outlined style="color: #94989a; font-size: 16px" />
          </template>
        </c-input>

        <slot name="extraAction" />
        <div
          v-if="showDownloadFileExcel"
          class="hover:cursor-pointer flex my-auto"
          @click="handleExportExcel"
        >
          <a-button :loading="loadingExportExcelAll" class="flex my-auto items-center">
            <template #icon>
              <download-outlined />
            </template>
            Xuất Excel
          </a-button>
        </div>
        <div
          v-if="showActions && device !== DEVICE_TYPE.MOBILE"
          class="hover:cursor-pointer flex my-auto"
          @click="reloadData"
        >
          <a-tooltip>
            <template #title>Lấy lại dữ liệu</template>
            <reload-icon />
          </a-tooltip>
        </div>
        <div
          v-if="showZoomOut"
          class="hover:cursor-pointer flex my-auto"
          @click="handleToggleFullScreen(true)"
        >
          <a-tooltip placement="topLeft">
            <template #title>Phóng to bảng toàn màn hình</template>
            <fullscreen-icon />
          </a-tooltip>
        </div>
        <div
          v-if="showSetting && showActions && device !== DEVICE_TYPE.MOBILE"
          class="hover:cursor-pointer flex my-auto"
          @click="visibleModalSetting = true"
        >
          <a-tooltip placement="topLeft">
            <template #title>Tùy chọn giao diện</template>
            <setting-icon />
          </a-tooltip>
        </div>
      </div>
    </template>
    <slot />
    <a-table
      v-if="showTable"
      ref="myTableRef"
      v-bind="$attrs"
      :bordered="border"
      :data-source="dataSource"
      :columns="columnsTable"
      class="c-table ant-table-striped"
      :loading="loading"
      :scroll="allowScroll ? { x: scrollX ? scrollX : '100%', y: scrollY } : null"
      :row-class-name="
        rowClassFunc
          ? rowClassFunc
          : (_record, index) => [
              index % 2 === 1 ? `${showStriped ? 'table-striped' : ''}` : '',
              selectedRowKey === _record.id ? 'row-active' : ''
            ]
      "
      ,
      :class="{ 'table-border': border }"
      :custom-row="customRow"
      @scroll="handleScrollTable"
    >
      <template v-for="(_, name) in $slots" :key="name" #[name]="slotData">
        <slot v-bind="slotData" :name="name" />
      </template>
      <template #emptyText>
        <a-empty :description="'Trống'" />
      </template>
    </a-table>
  </a-card>
  <a-modal
    v-if="visibleFullScreen"
    v-model:visible="visibleFullScreen"
    width="100%"
    class="fullscreen bg-white"
    wrap-class-name="full-modal"
    :footer="false"
    :body-style="{
      background: '#FFFFFF'
    }"
  >
    <a-card class="card-table" :class="{ 'table-custom-header': !title }">
      <template #title>
        <div v-if="title" class="cursor-pointer outline-none">
          <caret-right-outlined :rotate="90" />
          <span class="font-semibold ml-[7px]"> {{ title }} </span>
        </div>
        <slot v-else name="customerTitle" />
      </template>
      <template #extra>
        <div class="flex items-center gap-4">
          <c-input
            v-if="showQuickSearch"
            v-model:value="quickSearch"
            style="width: 300px"
            placeholder="Tìm kiếm nhanh..."
            @change="handleChangeValueSearch"
          >
            <template #prefix>
              <search-outlined style="color: #94989a; font-size: 16px" />
            </template>
          </c-input>
          <slot name="extraAction" />
          <div
            v-if="showDownloadFileExcel"
            class="hover:cursor-pointer flex my-auto"
            @click="handleExportExcel"
          >
            <a-button class="flex my-auto items-center">
              <template #icon>
                <download-outlined />
              </template>
              Xuất Excel
            </a-button>
          </div>
          <div v-if="showActions" class="hover:cursor-pointer flex my-auto" @click="reloadData">
            <a-tooltip>
              <template #title>Lấy lại dữ liệu</template>
              <reload-icon />
            </a-tooltip>
          </div>
          <div class="hover:cursor-pointer flex my-auto" @click="handleToggleFullScreen(false)">
            <a-tooltip placement="topLeft">
              <template #title>Thu nhỏ bảng</template>
              <fullscreen-exit-outlined :style="{ fontSize: '20px', color: '#73777A' }" />
            </a-tooltip>
          </div>
          <div
            v-if="showSetting"
            class="hover:cursor-pointer flex my-auto"
            @click="visibleModalSetting = true"
          >
            <a-tooltip placement="topLeft">
              <template #title>Tùy chọn giao diện</template>
              <setting-icon />
            </a-tooltip>
          </div>
        </div>
      </template>
      <a-table
        v-if="showTable"
        v-bind="$attrs"
        :bordered="border"
        :data-source="dataSource"
        :columns="columnsTable"
        class="c-table ant-table-striped"
        :loading="loading"
        :scroll="allowScroll ? { x: scrollX ? scrollX : '100%', y: scrollY } : null"
        :row-class-name="
          rowClassFunc
            ? rowClassFunc
            : (_record, index) => [
                index % 2 === 1 ? `${showStriped ? 'table-striped' : ''}` : '',
                selectedRowKey === _record.id ? 'row-active' : ''
              ]
        "
        :class="{ 'table-border': border }"
        :custom-row="customRow"
        @scroll="handleScrollTable"
      >
        <template v-for="(_, name) in $slots" :key="name" #[name]="slotData">
          <slot v-bind="slotData" :name="name" />
        </template>
        <template #emptyText>
          <a-empty :description="'Trống'" />
        </template>
      </a-table>
      <slot />
    </a-card>
  </a-modal>
  <a-drawer
    title="Cấu hình table"
    size="large"
    :visible="visibleModalSetting"
    :z-index="1000"
    :body-style="{ paddingBottom: '80px' }"
    @close="handleCloseSetting"
  >
    <drop-table
      :columns="columnsTable"
      :fields-column-ignore-config="fieldsColumnIgnoreConfig"
      @update:columns="handleUpdateColumn"
    />
  </a-drawer>
</template>

<script lang="ts">
export default {
  name: 'TableCustom'
}
</script>
<script setup lang="ts">
import {
  CaretRightOutlined,
  SearchOutlined,
  DownloadOutlined,
  FullscreenExitOutlined
} from '@ant-design/icons-vue'
import FullscreenIcon from '@/assets/svg/FullscreenIcon.vue'
import ReloadIcon from '@/assets/svg/ReloadIcon.vue'
import SettingIcon from '@/assets/svg/SettingIcon.vue'
import { ref, watch, onMounted, computed } from 'vue'
import debounce from 'lodash/debounce'
import { useRouter } from 'vue-router'
import { onExportExcel } from '@/utils'
import { useGlobalStore } from '@/stores/globalStore.ts'
import { DEVICE_TYPE } from '@/contants'
import _ from 'lodash'
import { object } from '@amcharts/amcharts4/core'

const props = defineProps({
  title: {
    type: String,
    default: 'Kết quả tìm kiếm'
  },
  columns: {
    type: Array,
    required: true
  },
  columnExcel: {
    type: Array,
    default: null
  },
  isShowIconColapse: {
    type: Boolean,
    default: true
  },
  border: {
    type: Boolean,
    default: false
  },
  rowClassFunc: {
    type: Function
  },
  loading: {
    type: Boolean,
    default: false
  },
  allowScroll: {
    type: Boolean,
    default: true
  },
  dataSource: {
    type: Array,
    required: true
  },
  dataExcel: {
    type: Array,
    default: null
  },
  isExportAll: {
    type: Boolean,
    default: false
  },
  isExportCustom: {
    type: Object,
    default: false
  },
  loadingExportExcelAll: {
    type: Boolean,
    default: false
  },
  scrollX: {
    type: [Number, null],
    required: false
  },
  scrollY: {
    type: Number,
    required: false
  },
  showDownloadFileExcel: {
    type: Boolean,
    default: true
  },
  showStriped: {
    type: Boolean,
    default: true
  },
  showActions: {
    type: Boolean,
    default: true
  },
  selectedRowKey: {
    type: Number,
    default: 0
  },
  showZoomOut: {
    type: Boolean,
    default: true
  },
  quickSearchValue: {
    type: String,
    default: ''
  },
  wrapperClass: {
    type: String,
    default: null
  },
  showQuickSearch: {
    type: Boolean,
    default: true
  },
  showSetting: {
    type: Boolean,
    default: true
  },
  showTable: {
    type: Boolean,
    default: true
  },
  showActiveRow: {
    type: Boolean,
    default: false
  },
  reloadData: Function
})
const device = computed(() => {
  const globalStore = useGlobalStore()
  const {
    state: { device }
  } = globalStore
  return device
})
const emit = defineEmits([
  'handleQuickSearch',
  'onClickRow',
  'handleExportExcel',
  'scroll',
  'onFirstRowScroll'
])
const selectedRow = ref(null)
const columnsTable = ref([])
const quickSearch = ref('')
const visibleModalSetting = ref(false)
const visibleFullScreen = ref(false)

const myTableRef = ref(null)

const router = useRouter()
const handleChangeValueSearch = debounce(() => {
  emit('handleQuickSearch', quickSearch.value)
}, 500)

const customRow = (record, index) => {
  return {
    onClick: () => {
      handleClickRowTable(record, index)
    },
    className:
      props.showActiveRow && index === selectedRow.value
        ? props.isShowRowActiveParent
          ? 'row-active'
          : record.children?.length
          ? ''
          : 'row-active'
        : ''
  }
}

const handleToggleFullScreen = (open = false) => {
  emit('onFirstRowScroll', {})
  visibleFullScreen.value = open
}

const handleExportExcel = () => {
  if (props.isExportCustom) {
    onExportExcel(props.columnExcel || props.columns, props.dataExcel || props.dataSource, router)
    return
  }
  if (props.isExportAll) {
    emit('handleExportExcel')
  } else {
    onExportExcel(props.columnExcel || props.columns, props.dataExcel || props.dataSource, router)
  }
}

const handleCloseSetting = () => {
  visibleModalSetting.value = false
}

const handleUpdateColumn = (columns: any[]) => {
  columnsTable.value = columns.filter((v: { hidden: any }) => !v.hidden)
}

const handleClickRowTable = (record, index) => {
  selectedRow.value = index
  emit('onClickRow', record)
}

const handleScrollTable = (e) => {
  emit('scroll', e)

  const tableBodyElement = e.target
  const scrollPosition = tableBodyElement.scrollTop

  const rows = tableBodyElement.querySelectorAll('.ant-table-row')
  let accumulatedHeight = 0

  let currentRowIndex = -1
  for (let i = 0; i < rows.length; i++) {
    const rowHeight = rows[i].clientHeight
    accumulatedHeight += rowHeight

    if (accumulatedHeight > scrollPosition + 20) {
      currentRowIndex = i
      break
    }
  }

  if (currentRowIndex !== -1) {
    const currentRow = props.dataSource[currentRowIndex]

    emit('onFirstRowScroll', currentRow)
  }
}

onMounted(() => {
  if (myTableRef.value) {
    const tableBodyElement = myTableRef.value.$el.querySelector('.ant-table-body')
    if (tableBodyElement) {
      tableBodyElement.addEventListener('scroll', handleScrollTable)
    }
  }
})

const filterColumns = (columns) => {
  return _.cloneDeep(columns)
    .map((col) => {
      if (col.children) {
        col.children = filterColumns(col.children)
      }
      return { ...col, hidden: col.hidden || false }
    })
    .filter((col) => !col.hidden)
}

watch(
  [() => props.loading, () => props.columns],
  () => {
    if (!props.loading && props.columns?.length) {
      columnsTable.value = filterColumns(props.columns)
    }
  },
  { immediate: true, deep: true }
)
</script>

<style lang="scss">
.table-custom-header {
  .ant-card-head-wrapper {
    align-items: end;
    gap: 5px;
  }
}
.card-table.ant-card-bordered {
  border: none;
  .ant-card-head {
    border: none;
    padding: 8px;
    .ant-card-head-title {
      padding: 0;
    }
  }
  .ant-card-extra {
    padding: 0;
  }
}

.card-table,
.customer-table {
  .ant-card-body {
    padding: 10px;
  }
}
.c-table,
.customer-table {
  .row-active {
    .ant-table-cell {
      background-color: #c0ecff !important;
    }
  }
  .table-striped td {
    background-color: #fafafa !important;
  }
  table {
    overflow-y: clip;
    tr > th,
    tr > td {
    }
    .ant-table-thead > tr > th {
      background: #fafafa;
      font-weight: 700;
    }
    tr > td {
      font-weight: 600;
    }
  }
  .ant-table-thead
    > tr
    > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not(
      [colspan]
    )::before {
    background-color: rgba(0, 0, 0, 0.25) !important ;
    width: 1px !important;
  }
  .ant-table-tbody > tr > td {
    border-bottom: 1px solid #f0f0f0;
    transition: background 0.3s;
  }
  .pagination {
    .ant-pagination-options {
      display: none;
    }
  }
  .ant-table-striped :deep(.table-striped) td {
    background-color: #d9d9d9;
  }
  .ant-table-ping-left {
    .ant-table-cell-fix-left {
      &::before {
        display: none;
      }
    }
  }
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    padding: 8px;
  }
}
.fullscreen {
  width: 100% !important;
  margin: 0;
  max-width: none !important;
  height: 100%;
  padding: 0 !important;
  top: 0 !important;
  .c-table {
    margin-top: 30px !important;
  }
  .ant-modal-content {
    height: 100% !important;
  }
  .ant-modal-body {
    padding-top: 50px !important;
  }
  table {
    .td-production {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 43px;
      &:hover {
        background: #1990ff;
        color: #000000 !important;
        .ant-input-suffix {
          width: 20px;
          border: 1px solid #00000040;
        }
      }
      input {
        cursor: pointer;
        transition: all 0.3s;
        height: 100%;
        text-align: center;
      }
      .ant-input-suffix {
        background: #ffffff;
        transition: all 0.3s;
        display: none;
        border-radius: 100px;
        border: 1px solid transparent;
        width: 0;
        height: 20px;
        justify-content: center;
        align-items: center;
      }
    }

    .ant-table-cell {
      min-width: 100px !important;
    }
    .ant-table-row {
      td {
        height: 45px !important;
        padding: 1px !important;
        max-width: 100px !important;
        &:first-child {
          padding-left: 10px !important;
        }
      }
    }
  }
  .th-input,
  .th-input-data,
  .td-input,
  .td-data {
    height: 100%;
    .c-input,
    input,
    .ant-input-number,
    .ant-input-affix-wrapper,
    .ant-input-number-input-wrap {
      width: 100% !important;
      height: 100% !important;
      border-radius: 5px !important;
      background: transparent !important;
      font-weight: 600;
      text-align: center;
    }

    .c-input__wrapper {
      input {
        border: none !important;
      }

      border-radius: 5px;
      border: 1px solid #9f9f9f4a !important;
      transition: 0.3s !important;
    }
    .c-input,
    .ant-input-number,
    .ant-input-affix-wrapper {
      input {
        border: none !important;
      }
      border-radius: 5px;
      border: 1px solid #9f9f9f4a !important;
      transition: 0.3s !important;
      &:hover {
        border: 1px solid rgba(24, 144, 255, 1) !important;
      }
    }
  }
  .th-input {
    input[disabled] {
      color: #000000 !important;
    }
  }
  .th-input-data {
    input {
      color: #2d3dd2;
    }
  }
}

.table-border {
  .ant-table-thead
    > tr
    > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not(
      [colspan]
    )::before {
    display: none !important;
  }
}
</style>
